import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Modal from "./Modal";

export default function Scanner({ open, onClose, onDetected }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const id = "scanner-region";
    const scanner = new Html5Qrcode(id);
    ref.current = scanner;
    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 160 } },
        (decoded) => onDetected(decoded),
        () => {}
      )
      .catch(() => {});
    return () => {
      if (ref.current) {
        ref.current.stop().then(() => ref.current && ref.current.clear()).catch(() => {});
        ref.current = null;
      }
    };
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title="Scan Barcode" testid="scanner-modal">
      <div id="scanner-region" className="w-full min-h-[240px] rounded-lg overflow-hidden border-2 border-[#0A0A0A] bg-black" />
      <p className="text-sm text-[#52525B] mt-3">Arahkan kamera ke barcode. Izinkan akses kamera saat diminta.</p>
    </Modal>
  );
}
